/**
 * Product Special Info Component
 * Manages modal functionality with content switching
 */
class ProductSpecialInfo extends HTMLElement {
  connectedCallback() {
    this.initializeModal();
  }

  initializeModal() {
    console.log('Product Special Info: Initializing modal...');
    
    const modal = this.querySelector('dialog-component');
    const buttons = this.querySelectorAll('.product-special-info__button_modal-open');
    const tabs = this.querySelectorAll('.product-special-info__tab');
    const contents = this.querySelectorAll('.product-special-info__content');
    const closeButton = this.querySelector('.product-special-info__close-button');

    console.log('Product Special Info: Found elements:', {
      modal: !!modal,
      buttons: buttons.length,
      tabs: tabs.length,
      contents: contents.length,
      closeButton: !!closeButton
    });

    if (!modal) {
      console.error('Product Special Info: dialog-component not found');
      return;
    }

    // Handle button clicks to open modal
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        console.log('Product Special Info: Button clicked');
        const contentType = button.getAttribute('data-content');
        console.log('Product Special Info: Content type:', contentType);
        this.switchContent(contentType, tabs, contents);
        if (modal.showDialog) {
          console.log('Product Special Info: Calling showDialog');
          modal.showDialog();
        } else {
          console.error('Product Special Info: showDialog method not found on modal');
          console.log('Product Special Info: Modal object:', modal);
        }
      });
    });

    // Handle tab clicks inside modal
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const contentType = tab.getAttribute('data-content');
        this.switchContent(contentType, tabs, contents);
      });
    });

    // Handle close button
    closeButton?.addEventListener('click', () => {
      if (modal.closeDialog) {
        modal.closeDialog();
      } else {
        console.error('Product Special Info: closeDialog method not found on modal');
      }
    });

    // Handle modal close events
    modal.addEventListener('dialog:close', () => {
      // Reset to first content when modal closes
      this.switchContent('description', tabs, contents);
    });
  }

  /**
   * Switches the active content and updates button/tab states
   * @param {string} contentType - The content type to show
   * @param {NodeList} tabs - All tab elements
   * @param {NodeList} contents - All content elements
   */
  switchContent(contentType, tabs, contents) {
    // Update tab states
    tabs.forEach(tab => {
      const isActive = tab.getAttribute('data-content') === contentType;
      tab.classList.toggle('product-special-info__tab--active', isActive);
      tab.setAttribute('aria-pressed', isActive.toString());
    });

    // Update content visibility
    contents.forEach(content => {
      const isActive = content.getAttribute('data-content') === contentType;
      content.classList.toggle('product-special-info__content--active', isActive);
    });

    // Update button states outside modal
    const buttons = this.querySelectorAll('.product-special-info__button');
    buttons.forEach(button => {
      const isActive = button.getAttribute('data-content') === contentType;
      button.classList.toggle('product-special-info__button--active', isActive);
      button.setAttribute('aria-pressed', isActive.toString());
    });
  }
}

// Define the custom element
if (!customElements.get('product-special-info')) {
  customElements.define('product-special-info', ProductSpecialInfo);
}
